import type { ReactNode, SelectHTMLAttributes } from 'react';

import { CONTROL } from './control';
import { cx } from './cx';
import { useInvalid } from './fieldProblem';

/**
 * A native `<select>`, deliberately.
 *
 * `color-scheme` in the token blocks is what makes its dropdown match the console — the
 * part of a browser a stylesheet does not reach — and a hand-rolled listbox would throw away
 * type-ahead, the keyboard and every assistive technology for the sake of a chevron.
 */
export function Select({
  className,
  children,
  id,
  onChange,
  'aria-describedby': describedBy,
  ...rest
}: { className?: string; children?: ReactNode } & Omit<
  SelectHTMLAttributes<HTMLSelectElement>,
  'className' | 'children'
>) {
  const invalid = useInvalid(id, describedBy, onChange);

  return (
    <select {...rest} {...invalid} id={id} className={cx(CONTROL, 'cursor-pointer', className)}>
      {children}
    </select>
  );
}
